var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "account_active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Back-Office",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compte",
    transform: "translate(-31.000000, -295.000000)",
    stroke: "#5AADB2",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "account_active",
    transform: "translate(31.750000, 295.750000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.27291667,0.76825 C4.52141667,-0.256083333 5.97858333,-0.256083333 6.22708333,0.76825 C6.30270844,1.08036787 6.52285301,1.33759747 6.81954674,1.46051839 C7.11624047,1.58343931 7.45379896,1.5572674 7.728,1.39008333 C8.62808333,0.84175 9.65883333,1.87191667 9.1105,2.77258333 C8.94355727,3.04666478 8.91744852,3.38396396 9.04022465,3.68047118 C9.16300077,3.9769784 9.4199168,4.1970842 9.73175,4.27291667 C10.7560833,4.52141667 10.7560833,5.97858333 9.73175,6.22708333 C9.41963213,6.30270844 9.16240253,6.52285301 9.03948161,6.81954674 C8.91656069,7.11624047 8.9427326,7.45379896 9.10991667,7.728 C9.65825,8.62808333 8.62808333,9.65883333 7.72741667,9.1105 C7.45333522,8.94355727 7.11603604,8.91744852 6.81952882,9.04022465 C6.5230216,9.16300077 6.3029158,9.4199168 6.22708333,9.73175 C5.97858333,10.7560833 4.52141667,10.7560833 4.27291667,9.73175 C4.19729156,9.41963213 3.97714699,9.16240253 3.68045326,9.03948161 C3.38375953,8.91656069 3.04620104,8.9427326 2.772,9.10991667 C1.87191667,9.65825 0.841166667,8.62808333 1.3895,7.72741667 C1.55644273,7.45333522 1.58255148,7.11603604 1.45977535,6.81952882 C1.33699923,6.5230216 1.0800832,6.3029158 0.76825,6.22708333 C-0.256083333,5.97858333 -0.256083333,4.52141667 0.76825,4.27291667 C1.08036787,4.19729156 1.33759747,3.97714699 1.46051839,3.68045326 C1.58343931,3.38375953 1.5572674,3.04620104 1.39008333,2.772 C0.84175,1.87191667 1.87191667,0.841166667 2.77258333,1.3895 C3.35591667,1.74416667 4.11191667,1.43033333 4.27291667,0.76825 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.25,
    cy: 5.25,
    r: 1.75
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountActive);
export default __webpack_public_path__ + "static/media/account_active.d05ffd748fe7bb992b193386e0429a46.svg";
export { ForwardRef as ReactComponent };